import React from 'react'
import { Phone, EnvelopeSimple } from 'phosphor-react'
import './Header.scss';

function NavbarInfo() {
    return (
        <div className='nav_info_otr'>
            <a href='tel:03708446009' className='info_linkk'>
                <Phone size={24} />
                <span className='linkk_text heading-sm'>
                    0370-8446009
                </span>
            </a>
            <a href='mailto:mshahzaibzahid0@gmail.com' className='info_linkk'>
                <EnvelopeSimple size={24} />
                <span className='linkk_text heading-sm'>
                    mshahzaibzahid0@gmail.com
                </span>
            </a>
        </div>
    )
}

export default NavbarInfo